import { ADVERT_FORMAT_TYPES } from '@web-platform/shared-universal-constants/src/adverts';

import type {
  ConductorCreativeAlternateDatesInlineFields,
  CreativeFlightsAlternateDatesInline,
} from '@web-platform/shared-universal-types/src/redux/acorn/state/flightsDayView/entitiesSearchResults/adverts/types';

export const getFlightsAlternateDatesInlineCreative = (
  fields: ConductorCreativeAlternateDatesInlineFields,
): CreativeFlightsAlternateDatesInline => {
  const {
    appIndex,
    callToActionText = null,
    carriersCriteria,
    ctaButtonTitle,
    excludedCarriers,
    includedCarriers,
    message,
    partner,
    partnerDesktopLogo,
    partnerLogo,
    partnerName,
    pioAgencyName,
    pioPartnerName,
    price,
    redirectUrl,
    splitTestId,
    sponsoredInfoText,
    title,
  } = fields;

  return {
    appIndex,
    callToActionText,
    ctaButtonTitle,
    format: ADVERT_FORMAT_TYPES.ALTERNATE_DATES_INLINE,
    message,
    partnerDesktopLogo,
    partnerLogo,
    partner,
    partnerName,
    redirectUrl,
    title,
    carriersCriteria: carriersCriteria || 'all',
    includedCarriers: includedCarriers ? includedCarriers.split(',').map(Number) : [],
    excludedCarriers: excludedCarriers ? excludedCarriers.split(',').map(Number) : [],
    splitTestId,
    price,
    sponsoredInfoText,
    pioPartnerName,
    pioAgencyName,
  };
};
